<template>
  <ul class="menu-nav">
    <template v-for="(menu, i) in menuItems">
      <KTMenuItem
        v-if="!menu.section && (!menu.role || menu.role === role)"
        :menu="menu"
        :key="i"
        @click="click"
      ></KTMenuItem>
      <KTMenuSection
        v-if="menu.section && (!menu.role || menu.role === role)"
        :menu="menu"
        :key="i"
        @click="click"
      ></KTMenuSection>
    </template>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import KTMenuItem from "@/view/layout/aside/MenuItem.vue";
import KTMenuSection from "@/view/layout/aside/MenuSection.vue";
import menuConfig from "@/core/config/menu.config.json";

export default {
  name: "KTAsideMenu",
  components: {
    KTMenuItem,
    KTMenuSection,
  },
  computed: {
    ...mapGetters(["role"]),
    menuItems: () => {
      return menuConfig.aside.items;
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>
